<template>
  <div
    id="js-product-details-delivery-dates-simple-container"
    class="product-details-delivery-date-simple"
    :data-product-id="productSlug"
    data-selected-color="Transfer"
    :data-is-dtf="isDtfSheet"
    data-assignable="true"
  >
    <div
      class="product-details-delivery-date-simple__loading js-product-details-delivery-dates-simple-spinner"
    >
      <span class="product-details-delivery-date-simple__loading-text">
        Getting Earliest Delivery Date
      </span>
      <slot name="dates"></slot>
    </div>

    <div
      class="product-details-delivery-date-simple__wrapper js-product-details-delivery-dates-simple-wrapper hidden"
    >
      <div
        class="product-details-delivery-date-simple__delivery js-product-details-delivery-dates-simple-shipment"
      >
        <UseSvg
          icon="box-jiffy-check"
          class="product-details-delivery-date-simple__delivery-icon"
        />
        <span class="product-details-delivery-date-simple__delivery-date-label">
          Get it
          <span
            class="js-product-details-delivery-dates-simple-direct-value product-details-delivery-date-simple__delivery-date-value"
          ></span>
        </span>
      </div>

      <div
        class="product-details-delivery-date-simple__cutoff js-product-details-delivery-dates-simple-cutoff-wrapper"
      >
        If ordered in the next
        <b
          class="js-product-details-delivery-dates-cutoff product-details-delivery-date-simple__cutoff-date"
          >...</b
        >
      </div>

      <button
        class="product-details-delivery-date-simple__change-location-button js-deliver-to-toggle-modal"
        type="button"
        data-mixpanel-context="product_detail"
      >
        <UseSvg
          icon="marker"
          class="product-details-delivery-date-simple__change-location-button-icon"
        />

        <span
          class="product-details-delivery-date-simple__deliver-to-message js-deliver-to-pdp-addr"
        >
          Select Your Address
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import UseSvg from "../vue-cart/UseSvg.vue";
import { useDtfStore } from "./store";

export default {
  name: "DeliveryDate",
  components: {
    UseSvg
  },
  computed: {
    ...mapState(useDtfStore, ["isDtfSheet", "productSlug"])
  }
};
</script>
